import { useLayoutEffect, useState } from 'react';
import debounce from 'lodash/debounce';
import { useDispatch } from 'react-redux';
import { isMobileStateChanged } from './layoutSlice';

const useLayoutService = () => {
  const dispatch = useDispatch()

  useLayoutEffect(() => {
    const updateSize = () => {
      dispatch(isMobileStateChanged({isMobile: window.innerWidth < 480}));
    };
    window.addEventListener('resize', debounce(updateSize, 250));
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);
};

export default useLayoutService;